const search = (() => {

    const initBlock = el => {
        paging.handlePaging(el, handleFilter);
    };

    const handleFilter = (el, pageId) => {
        const pageSize = el.dataset.pagesize;
        const searchTerm = el.dataset.searchterm;
        let resultsWrapper = el.querySelector('[data-search-results]');
        fetch(`/umbraco/surface/search/get?pageSize=${pageSize}&pageId=${pageId}&searchTerm=${searchTerm}`)
            .then(response => response.text())
            .then(data => {
                if (resultsWrapper && data){
                    resultsWrapper.outerHTML = data;
                    resultsWrapper = el.querySelector('[data-search-results]');
                    paging.handlePaging(el, handleFilter);
                }
            })
            .catch(_ => {});
    }
    return {initBlock};
})();
document.querySelectorAll('[data-search]').forEach(el => search.initBlock(el));